import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { BudgetService } from "./budget.service";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import {  CommonResponseModel } from "@project-management-system/shared-models";
import { BudgetDto } from "./budget.dto";


@Controller('budget')
@ApiTags('/budget')
export class BudgetController {
    constructor(private service: BudgetService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/getAllBudget')
    async getAllBudget(): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllBudget();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/createBudget')
    @ApiBody({ type: BudgetDto })
    async createBudget(@Body() req: any): Promise<CommonResponseModel> {
        try {
            // console.log(req, 'ppppppppppp');

            return await this.service.createBudget(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }

    }

    @Post('/getActiveAllBudget')
    async getActiveAllBudget(): Promise<CommonResponseModel> {
        try {
            return await this.service.getActiveAllBudget();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/updateBudget')
    @ApiBody({ type: BudgetDto })
    async updateBudget(@Body() req: any): Promise<CommonResponseModel> {
        try {


            return await this.service.updateBudget(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateBudget')
    @ApiBody({ type: BudgetDto })
    async activateOrDeactivateBudget(@Body() dto: any, isUpdate: boolean = false): Promise<CommonResponseModel> {
        try {
            return await this.service.activateOrDeactivateBudget(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getBudgetCostReport')
    async getBudgetCostReport(@Body() req:any): Promise<CommonResponseModel> {
        try {
            return await this.service.getBudgetCostReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }
}